@use "/src/styles/functions.scss";
@use "/src/styles/mixins.scss";

$animation-time: functions.speed(fast);

@mixin default {
  border: 1px solid functions.getThemeColor(stroke-soft-200);
  background-color: functions.getThemeColor(bg-white-0);
  outline: 2px solid transparent;

  @include mixins.fontType(paragraph-small);

  :global(.icon) {
    color: functions.getThemeColor(icon-sub-600);
  }

  &:has(input:placeholder-shown) {
    :global(.icon) {
      color: functions.getThemeColor(icon-soft-400);
    }
  }

  &::placeholder,
  input::placeholder {
    color: functions.getThemeColor(text-soft-400);
    transition: color $animation-time ease-in-out;
  }
}

@mixin hover {
  &:hover {
    background-color: functions.getThemeColor(bg-weak-50);
    border-color: functions.getThemeColor(bg-weak-50);

    :global(.icon) {
      color: functions.getThemeColor(icon-sub-600) !important;
    }

    &::placeholder,
    input::placeholder {
      color: functions.getThemeColor(text-sub-600);
    }
  }
}

@mixin focus {
  &:focus-within,
  :focus {
    outline-color: functions.getThemeColor(stroke-soft-200);
    border-color: functions.getThemeColor(stroke-strong-950);
    background-color: functions.getThemeColor(bg-white-0);

    :global(.icon) {
      color: functions.getThemeColor(icon-sub-600) !important;
    }
    z-index: 1;
    &::placeholder,
    input::placeholder {
      color: functions.getThemeColor(text-sub-600);
    }
  }
}

@mixin readOnly {
  background-color: functions.getThemeColor(bg-white-0) !important;
  border-color: functions.getThemeColor(stroke-soft-200) !important;
}

@mixin disabled {
  background-color: functions.getThemeColor(bg-weak-50) !important;
  border-color: functions.getThemeColor(bg-weak-50) !important;
  color: functions.getThemeColor(text-disabled-600) !important;
  outline-color: transparent !important;
  cursor: default;

  :global(.icon) {
    color: functions.getThemeColor(icon-disabled-300) !important ;
  }

  &::placeholder,
  input::placeholder {
    color: functions.getThemeColor(text-disabled-300) !important;
  }
}

@mixin error {
  &[data-isinvalid="true"],
  :invalid {
    border-color: functions.getThemeColor(state-error-base) !important;
    &:focus-within,
    &:focus {
      outline-color: functions.getThemeColor(state-error-light);
    }
    @content;
  }
}

@mixin autoTextAlignment {
  /* Or what selector you need */
  unicode-bidi: plaintext;

  /* Align text automatically left/right*/
  text-align: start;
}

@mixin appearance-none {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

@mixin baseFormControl {
  border-radius: functions.radius(10);
  transition: all $animation-time ease-in-out;
  outline-offset: 2px;

  &[data-size="medium"] {
    min-height: functions.space(40);
  }

  &[data-size="small"] {
    min-height: functions.space(36);
  }

  &[data-size="x-small"] {
    min-height: functions.space(32);
  }
}

@mixin formControl {
  @include baseFormControl();

  @include default();

  @include hover();

  &:focus {
    @include focus();
  }

  &:focus-within {
    @include focus();
  }
}

@mixin inputFormControl {
  @include autoTextAlignment();

  // order is important
  @include formControl();

  &:read-only {
    @include readOnly();
  }

  @include error {
    &:read-only {
      border-color: functions.getThemeColor(state-error-light) !important;
    }
  }

  &:disabled {
    @include disabled();
  }
}

@mixin data-read-only {
  &[data-read-only="true"] {
    @content;
  }
}

@mixin data-disabled {
  &[data-disabled="true"] {
    @content;
  }
}

@mixin containerFormControl {
  cursor: text;

  // order is important
  @include formControl();

  @include data-read-only {
    @include readOnly();
  }

  @include error {
    @include data-read-only {
      border-color: functions.getThemeColor(state-error-light) !important;
    }
  }

  @include data-disabled {
    @include disabled();
  }
}

.inputBox {
  display: flex;
  gap: functions.space(8);
  justify-content: center;
  align-items: center;
  // @include mixins.padding-start(functions.space(12));
  padding-inline-start: functions.space(12);
  padding-inline-end: functions.space(10);
  @include containerFormControl();
}

.center {
  text-align: center;
}
